import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { LoginRoute } from 'src/public/publicRoutes';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { authActions, RedirectUrl } from 'src/state/auth/authActions';
import { useGatsbyLikeNavigate } from 'src/common/migration/useGatsbyLikeNavigate';

export const useLoggedInGuard = (redirectUrl?: RedirectUrl): boolean => {
  const navigate = useGatsbyLikeNavigate();
  const dispatch = useDispatch();
  const { isLoading, isLoggedIn } = useIsLoggedIn();

  useEffect(() => {
    dispatch(authActions.setRedirectUrl(redirectUrl ?? null));
  }, []);

  useEffect(() => {
    if (!isLoading && !isLoggedIn) {
      navigate(LoginRoute, { replace: true });
    }
  }, [isLoading, isLoggedIn]);

  return !isLoading && isLoggedIn;
};
